import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={50}
    fill="none"
    {...props}
  >
    <g opacity={0.6}>
      <path
        fill="#B1BBC1"
        d="M5 43.75c0 .663 2.107 1.299 5.858 1.768 3.75.469 8.838.732 14.142.732s10.391-.263 14.142-.732c3.75-.47 5.858-1.105 5.858-1.768s-2.107-1.299-5.858-1.768c-3.75-.469-8.838-.732-14.142-.732s-10.391.263-14.142.732C7.108 42.452 5 43.087 5 43.75Z"
        opacity={0.1}
      />
      <path
        fill="#DDE6EB"
        d="M5.7 18.4c0 .425.324.75.75.75.424 0 .75-.325.75-.75a.737.737 0 0 0-.75-.75c-.4 0-.75.35-.75.75Zm39.55 22.225c-.95.25-1.15.45-1.376 1.375-.25-.95-.45-1.15-1.375-1.375.925-.25 1.15-.45 1.375-1.375.225.925.425 1.15 1.375 1.375ZM9.873 15.775c-1.225.325-1.475.575-1.8 1.8-.325-1.225-.575-1.475-1.8-1.8 1.225-.325 1.475-.6 1.8-1.8.3 1.225.575 1.475 1.8 1.8Zm30-4.3c-.75.2-.9.35-1.1 1.1-.2-.75-.35-.9-1.1-1.1.75-.2.9-.35 1.1-1.1.175.75.35.9 1.1 1.1Zm3.225-3.85c-1.95.5-2.35.925-2.875 2.875-.5-1.95-.925-2.35-2.875-2.875 1.95-.5 2.35-.925 2.875-2.875.5 1.925.925 2.35 2.875 2.875Z"
        opacity={0.5}
      />
      <path
        fill="#728389"
        d="M42 26.95v-.05c0-.05-.025-.075-.025-.125v-.025L36.6 12.725a5.749 5.749 0 0 0-5.475-3.975H18.9c-2.5 0-4.7 1.6-5.475 3.975L8.05 26.75v.025c-.025.05-.025.075-.025.125V37a5.75 5.75 0 0 0 5.75 5.75h22.5a5.75 5.75 0 0 0 5.75-5.75V27C42 26.975 42 26.975 42 26.95Zm-27.175-13.7s0-.025.025-.025c.55-1.8 2.2-2.975 4.05-2.975h12.2a4.27 4.27 0 0 1 4.075 2.95s0 .025.025.025l4.975 13H28.75a.737.737 0 0 0-.75.75c0 1.65-1.35 3-3 3s-3-1.35-3-3a.737.737 0 0 0-.75-.75H9.85l4.975-12.975ZM40.5 37c0 2.35-1.9 4.25-4.25 4.25h-22.5c-2.35 0-4.25-1.9-4.25-4.25v-9.25h11.075A4.489 4.489 0 0 0 25 31.5a4.489 4.489 0 0 0 4.425-3.75H40.5V37Z"
        opacity={0.5}
      />
      <path
        fill="#DDE6EB"
        d="M25 28.25c-.7 0-1.25-.55-1.25-1.25v-2.5H12.375l4.1-10.7.025-.05c.35-1.05 1.3-1.75 2.4-1.75h12.2c1.1 0 2.05.7 2.4 1.75l.025.05 4.1 10.7H26.25V27c0 .7-.55 1.25-1.25 1.25Z"
        opacity={0.2}
      />
    </g>
  </svg>
);
export default SvgComponent;
